import React, { useState } from "react";
import TextInput from "./TextInput";
import APP_CONFIG from "../../APP_CONFIG";

const TYPE_PASSWORD = "password";
const TYPE_TEXT = "text";

const PasswordInput = ({ type, className, ...rest }) => {
    const [customType, setCustomType] = useState(TYPE_PASSWORD);

    const SHOW_ICON = (
        <img alt="show" src={APP_CONFIG.IMAGES.SHOW_HIDE_ICON} height="20px" width="20px" />
    );
    const HIDE_ICON = (
        <img alt="hide" src={APP_CONFIG.IMAGES.SHOW_EYE_ICON} height="20px" width="20px" />
    );

    const handlePasswordToggle = () => {
        setCustomType((prevType) => (prevType === TYPE_TEXT ? TYPE_PASSWORD : TYPE_TEXT));
    };

    return (
        <TextInput
            type={customType}
            inputClasses="input-icon-padding"
            className={className}
            {...rest}
        >
            <div className="input-icon cursor-pointer" onClick={handlePasswordToggle}>
                {customType === TYPE_PASSWORD ? SHOW_ICON : HIDE_ICON}
            </div>
        </TextInput>
    );
};

export default PasswordInput;
